export enum ElementEditor {
    Tiptap = 'tiptap',
    DraftJs = 'draft-js',
    None = 'none', // not a text element
}
